<template>
  <div id="mainApp" @click="outsideClick">
    <router-view />
    <div class="el-card__navigator" @click.stop="cardClick" v-show="cardShow" @keydown.stop="navigatorKeydownEvent">
      <el-card shadow="always" :body-style="bodyStyle">
        <el-form :model="form" ref="form" :rules="rules" :show-message="false" @submit.native.prevent
          class="inline-block-form">
          <el-form-item prop="url">
            <el-input placeholder="请输入访问地址" v-model="form.url" size="medium" clearable>
              <el-button slot="append" @click.stop="submit">GO</el-button>
            </el-input>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import { formValid } from '@/utils/form'
import { regex } from '@/utils/regex'
export default {
  name: 'App',
  data () {
    return {
      form: {
        url: ''
      },
      rules: {
        url: [{ required: true, message: '请输入访问地址' }, { validator: formValid.validInputByReg, message: '输入的访问地址格式不对', reg: regex.url }]
      },
      cardShow: false,
      bodyStyle: {
        padding: '15px 20px'
      }
    }
  },
  created () {
    window.addEventListener('message', event => {
      const { data, type } = event.data || {}
      if (['beforeHistoryChange', 'afterHistoryChange'].includes(type) && data && data.url) {
        console.log('🚀 ~ file: App.vue:41 ~ created ~ data.url', data.url)
        window.history.replaceState(null, '', data.url)
      }
    })
  },
  mounted () {
    document.addEventListener('keydown', this.keydownEvent)
    /* let _this = this
    window.addEventListener('load', function () {
      console.log('🚀 ~ file: App.vue:51 ~ _this:', _this)
      _this.onload()
    })

    _this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('load', _this.onload, false)
    }) */
  },
  computed: {
    isClient () {
      return !!window.IAgencyWebCall
    }
  },
  methods: {
    onload () {
      if (!this.isClient) {
        return
      }
      var jqueryScript = document.createElement('script')
      jqueryScript.src = 'chrome-extension://lanikdpdfnfnelpaokgmdkemmfofdiif/js/inject.js'
      jqueryScript.type = 'text/javascript'
      jqueryScript.onload = function () {
      }
      document.body.appendChild(jqueryScript)
    },
    keydownEvent (event) {
      const keyCode = event.keyCode || event.which
      if (event.altKey && keyCode === 81) { // Alt + Q
        this.cardShow = !this.cardShow
      } else if (this.cardShow && keyCode === 27) {
        this.cardShow = false
      }
    },
    outsideClick (event) {
      this.cardShow = false
    },
    cardClick (event) {
      console.log('🚀 ~ file: App.vue:28 ~ cardClick ~ event', event)
    },
    navigatorKeydownEvent (event) {
      const keyCode = event.keyCode || event.which
      if (keyCode === 13) {
        this.submit()
      } else if (this.cardShow && keyCode === 27) {
        this.cardShow = false
      }
    },
    changeLocation () {
      const reg = /^\/|(http(s)?:\/\/)|\/$/g
      const url = this.form.url
      const { protocol } = window.location
      window.location.href = `${protocol}//${url.replace(reg, '')}`
    },
    submit () {
      this.$refs['form'].validate((valid, errors) => {
        if (valid) {
          this.changeLocation()
        } else {
          console.log('valid = ', errors)
          this.$message.warning(errors['url'][0].message)
        }
      })
    }
  }
}
</script>

<style lang="less">
body {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
  font-family: "Microsoft YaHei";
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  margin: 0;
}
.el-card {
  &__navigator {
    position: fixed;
    width: 600px;
    top: 100px;
    left: 50%;
    transform: translateX(-300px);
    z-index: 10;
    .inline-block-form {
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #999;
}
::-webkit-scrollbar-thumb {
  background-color: #d6d6d6;
  border-radius: 4px;
}
::-webkit-scrollbar-track {
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue